import React from 'react'
import styled from 'styled-components'
import { string, element, object, func, array, bool, oneOfType } from 'prop-types'
import { Box } from '@material-ui/core'
import { category } from '../../../config'
import { useHistory } from 'react-router-dom'

const Category = styled.div`
  font-size: 1.2em;
  color: ${props => props.$selected ? 'var(--first)' : 'var(--second)'};
  cursor: pointer;
  padding: 10px;
  font-weight: bold;
  &:hover {
    color: var(--first);
    font-weight: bold;
  }
`
const Name = styled.div`
  font-size: 1.2em;
  color: var(--second);
  cursor: pointer;
  padding: 5px 0px;
  &:hover {
    color: var(--first);
  }
`

const CategoryComponent = props => {
  const history = useHistory()

  return (
    <Box>
      <Category $selected={props.open || props.$selected} onClick={event => props.setCategory(props.category)}> {(category[props.category] || 'TODOS').toUpperCase()} </Category>
      {props.open && props.items && props.items.map(item => (
        <Box pl={4} key={item.id}>
          <Name onClick={event => history.push(`/item/${item.id}`)}>
            {item.title}
          </Name>
        </Box>
      ))}
    </Box>
  )
}

CategoryComponent.propTypes = {
  category: oneOfType([string, element, object]),
  setCategory: func,
  items: array,
  open: bool,
  $selected: bool
}

export default CategoryComponent
